import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useState, useEffect } from "react";
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import {Delete as DeleteIcon} from "@mui/icons-material";
import {IconButton} from "@mui/material";
import Button from "@mui/material/Button";
import "../App.css";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
const ModalStyle = {
  position: "absolute",
  borderRadius: "5px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  pb:1,
  pr:1,
  color:'black'
};



export default function InventoryRefund({props}) {
  let {studentName, studentId, userId,academicYearId,navigateToRefundTab } = props
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("fees_slab");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [inventoryRefund, setInventoryRefund] = useState([]);
  const [totalRefundable, setTotalRefundable] = useState(0);
  const [markedForDelete, setMarkedForDelete] = useState([]);
  const [productId, setProductId] =useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState({});
  const [salesDetailsIdset, setSalesDetailsIdset] = useState([]);
  const [quantitySelected, setQuantitySelected] = useState();
  const [refundId, setRefundId] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

const [validationErrors, setValidationErrors] = useState({});
const [quantitySum, setQuantitySum] = useState();
const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
const [deleteMsg, setDeleteMsg] = useState("");
const [refundTypeId, setRefundTypeId] = useState();
const [disabledRows, setDisabledRows] = useState([]);
const [saleStatus, setSaleStatus] = useState([]);
const [paidStatusId, setPaidStatusId] = useState(null);
const [issuedStatusId, setIssuedStatusId] = useState(null);
const [createdStatusId, setCreatedStatusId] = useState(null);
const [refundSaleStatusId, setRefundSaleStatusId] = useState(null);
const [partialRefundSaleId, setPartialRefundSaleId] = useState(null);
const [isLoading, setIsLoading] = useState(false);



 const getSaleStatus = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getSalesStatus`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json();
  
        // Extract specific sale_status_id for descriptions "Paid" and "Issued"
        const createdStatus =
          data.find((item) => item.description === "Created")?.sales_status_id ||
          null;
        const paidStatus =
          data.find((item) => item.description === "Paid")?.sales_status_id ||
          null;
        const issuedStatus =
          data.find((item) => item.description === "Issued")?.sales_status_id ||
          null;
        const partialRefundStatus =
          data.find((item) => item.description === "Partial Refund")?.sales_status_id ||
          null;
        const refundStatus =
          data.find((item) => item.description === "Refunded")?.sales_status_id ||
          null;
  
  
        // Set the complete data and the extracted IDs in state
        setSaleStatus(data);
        setCreatedStatusId(createdStatus);
        setPaidStatusId(paidStatus);
        setIssuedStatusId(issuedStatus);
        setPartialRefundSaleId(partialRefundStatus);
        setRefundSaleStatusId(refundStatus);
      } catch (error) {
        console.error("Error fetching sales status:", error);
      }
    };
  
    useEffect(() => {
      getSaleStatus();
    }, []);

  const navigate = useNavigate();
const cancelDelete = () => {
  setIsConfirmationOpen(false);
  setMarkedForDelete([]);
  setDisabledRows([]);
  setTotalRefundable(0);
  setSelectedQuantity({});
 
};
const handlePopUp = () => {
    setDeleteMsg("Please select product before proceeding with the refund.");
    setIsConfirmationOpen(true);
  
};
const handlePopUpConfirm = () => {
  setDeleteMsg("Are you sure you want to refund the selected products?");
  setIsConfirmationOpen(true);

};

  useEffect(() => {
    getInventoryRefund();
  }, [studentId, academicYearId]);
  const getInventoryRefund = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/refund/getInventoryRefund",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: 'include',
          body: JSON.stringify({
            student_id: studentId,
            academic_year_id: academicYearId,
          }),
        }
      );
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return;
      }
  
      const data = await response.json();
      console.log("inventory refund api", data.inventoryRefund)
      setInventoryRefund(data.inventoryRefund)
  
          setRefundTypeId(data.refundDetails[0].refund_type_id); // Assuming setRefundId is defined
         
   
    } catch (error) {
      console.error("Error fetching refund data:", error);
    }
  };
 

const saveInventoryRefund = async () => {
   setIsLoading(true); // Start loading
  try {
    const response = await fetch(
      `${process.env.REACT_APP_JHS_DEVELOPMENT}/refund/saveRefund`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: 'include',
        body: JSON.stringify({
          student_id: studentId,
          refund_type_id: refundTypeId,
          refund_amount: totalRefundable,
          refund_date: new Date(),
          academic_year_id: academicYearId,
          description: `${quantitySum} products refunded`,
          created_by: userId,
        }),
      }
    );
    if (response.status === 401) {
      console.log("Unauthorized access, redirecting to Sign-In...");
      navigate("/signin"); // Redirect if unauthorized
      return;
    }

    const responseData = await response.json();
    handleResponse(responseData);
    const newRefundId = responseData.refund_id;
    // Use newRefundId directly in addInventoryRefund
    await addInventoryRefund(newRefundId);

    // Optionally update the state if needed elsewhere
    setRefundId(newRefundId);
    

  } catch (error) {
    console.error("Error submitting refund details:", error);
  }finally {
    setIsLoading(false); // ✅ This is correct
  }
};
  useEffect(() => {
    console.log("Updated selectedQuantity:", selectedQuantity);
  }, [selectedQuantity]); // Runs whenever `selectedQuantity` changes


const handleDelete = (salesDetailsId, rowPrice, product_id, quantity, studentId, sales_id) => {
  // Get the total quantity using selectedQuantity from the state, falling back to the default quantity if not selected
  const totalQuantity = selectedQuantity[salesDetailsId] != null ? selectedQuantity[salesDetailsId] : quantity;

    // Validation: Ensure quantity is within a valid range
    if (totalQuantity < 1 || totalQuantity > quantity|| totalQuantity === null ){
      console.error(`Error: Quantity can not exceed ${quantity}.`);
      return; // Exit function early if validation fails
    }

  if (typeof rowPrice === "number" && !isNaN(rowPrice)) {
    // Check if this row has already been marked for deletion to avoid duplicate entries
    const isAlreadyMarked = markedForDelete.some((item) => item.salesDetailsId === salesDetailsId);
    

    if (!isAlreadyMarked) {
      // Calculate row total price
      const calculatedRowTotalPrice = rowPrice * totalQuantity;

      // Use functional update for state to handle the latest values properly
      setMarkedForDelete((prev) => {
        // Add new row to the list of rows marked for deletion
        const updatedMarkedForDelete = [
          ...prev,
          {
            salesDetailsId,
            calculatedRowTotalPrice,
            productId: product_id,
            quantity,  
            studentId,
            salesId: sales_id,
            rowPrice,
            quantitySelected: selectedQuantity[salesDetailsId] || null,
          },
        ];

        // Calculate total quantity sum after adding the new row
        const totalQuantitySum = updatedMarkedForDelete.reduce((sum, item) => {
          const rowQuantity = selectedQuantity[item.salesDetailsId] !== undefined && selectedQuantity[item.salesDetailsId] !== null
            ? selectedQuantity[item.salesDetailsId]  // Use quantitySelected if it's defined
            : item.quantity;  // Otherwise, fallback to the quantity from the row
          return sum + rowQuantity;
        }, 0);

        // Update quantity sum after modifying markedForDelete
        setQuantitySum(totalQuantitySum);
       

        // Return the updated markedForDelete state
        return updatedMarkedForDelete;
      });

      // Update refundable amount
      setTotalRefundable((prevTotal) => prevTotal + calculatedRowTotalPrice);
       // Add the row to disabledRows
       setDisabledRows((prev) => [...prev, salesDetailsId]);
    

      // Log values for debugging
      setProductId(product_id);
     
    } else {
      console.warn("This row has already been marked for deletion:", salesDetailsId);
    }
  }
};

const handleQuantityChange = (salesDetailsId, value, maxQuantity) => {
  // Parse the numeric value
  const numericValue = parseInt(value, 10);

  if (value === "" || isNaN(numericValue)) {
    // Allow clearing the input field
    setValidationErrors((prev) => ({
      ...prev,
      [salesDetailsId]: `Quantity is required`,
    }));
    setSelectedQuantity((prev) => ({
      ...prev,
      [salesDetailsId]: "",
    }));
  } 
  else if (numericValue > maxQuantity) {
    // Show error message for invalid input
    setValidationErrors((prev) => ({
      ...prev,
      [salesDetailsId]: `Quantity cannot exceed ${maxQuantity}`, 
    }));
  }else if(numericValue < 1 ){
    setValidationErrors((prev) => ({
      ...prev,
      [salesDetailsId]: ``, 
    }));
  }
   else {
    // Clear any errors and update the valid value
    setValidationErrors((prev) => ({
      ...prev,
      [salesDetailsId]: null,
    }));
    setSelectedQuantity((prev) => ({
      ...prev,
      [salesDetailsId]: numericValue,
    }));
  }
};

// useEffect to update `quantitySelected` whenever `selectedQuantity` changes
useEffect(() => {
  const salesDetailsId = salesDetailsIdset;

  if (selectedQuantity[salesDetailsId] !== undefined) {
    const updatedQuantity = selectedQuantity[salesDetailsId];
    setQuantitySelected(updatedQuantity);
    console.log("Updated Quantity:", updatedQuantity); // Log the extracted quantity
    console.log("Updated quantitySelected:", quantitySelected);
  }
}, [selectedQuantity, salesDetailsIdset]);

const addInventoryRefund = async (newRefundId) => {
  try {
    // Map over the markedForDelete array to prepare the payload
    const rowsPayload = markedForDelete.map((row) => ({
      product_id: row.productId,
      quantity: row.quantitySelected ? row.quantitySelected : row.quantity, // Use quantitySelected if it exists, otherwise use quantity
      price: row.rowPrice,
      student_id: row.studentId,
      sales_id: row.salesId,
      refund_id: newRefundId,
      created_by: userId, // Assuming userId is already defined in your state or context
      updated_by:userId,
      sale_status_id: refundSaleStatusId,
      sales_status_id: partialRefundSaleId
    }));
    console.log("rows", rowsPayload)

    // Send the request with the rowsPayload
    const response = await fetch(
      `${process.env.REACT_APP_JHS_DEVELOPMENT}/refund/addInventoryRefund`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: 'include',
        body: JSON.stringify({
          rows: rowsPayload// Send the prepared rows data in the request
        }),
      }
    );
    if (response.status === 401) {
      console.log("Unauthorized access, redirecting to Sign-In...");
      navigate("/signin"); // Redirect if unauthorized
      return;
    }
    const responseData = await response.json();
    

    // Handle the response data if needed
    setTotalRefundable(0); // Reset the total refundable value after successful submission

  } catch (error) {
    console.error("Error submitting refund details:", error);
  }
};


const deleteInventoryRefund = async (markedForDelete) => {
  const payload = markedForDelete.map((item) => {
    // Create a rowPayload for each item in markedForDelete
    const rowPayload = {
      salesDetailsId: item.salesDetailsId,
      // Only add quantitySelected if it exists, otherwise set quantity to null
      quantitySelected: item.quantitySelected !== undefined ? item.quantitySelected : null,
      // If quantitySelected is not set, add quantity; otherwise, set it to null
      quantity: item.quantitySelected ===null? item.quantity:null,
      product_id: item.productId,

      sales_id: item.salesId,                 // 🔥 needed
      sale_status_id: refundSaleStatusId,     // full refund status
      sales_status_id: partialRefundSaleId,   // partial refund status
      updated_by: userId                      // update user
    };
  
    return rowPayload;
  });
 
  fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/refund/deleteInventoryRefund", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: 'include',
    body: JSON.stringify({
      refunds: payload
    }),
  })
    .then((response) => {
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return; // Stop further execution
      }
      return response.json(); // Parse response JSON
    })
    .then((response) => {
      if (response) {
        handleResponse(response);
        setMarkedForDelete([]); // Reset the state after successful deletion
      }
    })
    .catch((error) => console.error("Error deleting inventory refund:", error));
  
};
const handleResponse = (responseObject) => {
  if (responseObject.status === 200) {
    setSnackbar({
      open: true,
      message: "Inventory Refund added successfuly.",
      severity: "success",
    });
  
  } 
};

const handleRefund = () => {
  if(markedForDelete.length > 0){
    
    handlePopUpConfirm();
}else{
  handlePopUp();
}
};

const proceedToRefund = ()=>{
  saveInventoryRefund();
      deleteInventoryRefund(markedForDelete);
      setTimeout(()=>{
      navigateToRefundTab();
      },2000)
    setTotalRefundable(0)
    getInventoryRefund();
    setIsConfirmationOpen(false);

}

const handleUndo = (salesDetailsIdToUndo) => {
  setMarkedForDelete((prev) => {
    // Filter out the rows being undone
    const updatedMarkedForDelete = prev.filter(
      (item) => item.salesDetailsId !== salesDetailsIdToUndo
    );

    // Recalculate the total quantity sum based on the updated rows
    const totalQuantitySum = updatedMarkedForDelete.reduce((sum, item) => {
      const rowQuantity =
        selectedQuantity[item.salesDetailsId] !== undefined &&
        selectedQuantity[item.salesDetailsId] !== null
          ? selectedQuantity[item.salesDetailsId]
          : item.quantity;
      return sum + rowQuantity;
    }, 0);

    // Update the quantity sum state
    setQuantitySum(totalQuantitySum);

    return updatedMarkedForDelete; // Update markedForDelete with filtered rows
  });

  // Reset the refundable amount by recalculating the remaining rows
  setTotalRefundable((prev) => {
    const rowToUndo = markedForDelete.find(
      (item) => item.salesDetailsId === salesDetailsIdToUndo
    );
    return rowToUndo
      ? prev - rowToUndo.calculatedRowTotalPrice
      : prev; // Adjust refundable amount
  });

  // Reset selected quantities for the undone row to its original value
  setSelectedQuantity((prev) => {
    const updatedQuantities = { ...prev };
    const originalRow = inventoryRefund.find(
      (row) => row.sales_details_id === parseInt(salesDetailsIdToUndo, 10)
    );
    if (originalRow) {
      updatedQuantities[salesDetailsIdToUndo] = originalRow.quantity;
    } else {
      delete updatedQuantities[salesDetailsIdToUndo]; // Remove the entry if no original value exists
    }
    return updatedQuantities;
  });


   // Enable the input field by removing the row from disabledRows
   setDisabledRows((prev) =>
    prev.filter((id) => id !== salesDetailsIdToUndo)
  );
  // setProductId("");
};

const handleToggleDelete = (salesDetailsId, rowPrice, product_id, quantity, studentId, sales_id) => {
  const isAlreadyMarked = markedForDelete.some((item) => item.salesDetailsId === salesDetailsId);

  if (isAlreadyMarked) {
    handleUndo(salesDetailsId); // Pass the specific `salesDetailsId` to undo
  } else {
    handleDelete(salesDetailsId, rowPrice, product_id, quantity, studentId, sales_id); // Trigger deletion
  }
};



  //  pagination and sorting
   const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    // Reset to default sorting when students are fetched
    setOrder("desc");
    setOrderBy("sales_details_id");
  }, [inventoryRefund]);



  // / Sorting function
  const handleRequestSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };
  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };
  // Sort the rows before displaying them
  const sortedRows = inventoryRefund
    .map((row, index) => ({ ...row, index: index + 1 })) // Add index for Serial No.
    .sort(getComparator(order, orderBy));


  return (
    <div >
      <div className="main_title">Issued Products List of {studentName}</div>
      <br />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {/* <StyledTableCell align='center' className="table-cell">SL No.</StyledTableCell> */}
              <StyledTableCell align="center" className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "sales_details_id"}
                      direction={orderBy === "sales_details_id" ? order : "desc"}
                      onClick={() => handleRequestSort("sales_details_id")}
                    >
                      SL No
                      {orderBy === "sales_details_id" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center" className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "product_name"}
                      direction={orderBy === "product_name" ? order : "desc"}
                      onClick={() => handleRequestSort("product_name")}
                    >
                      Product
                      {orderBy === "product_name" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center"  className="table-cell"> <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "issue_date"}
                      direction={orderBy === "issue_date" ? order : "desc"}
                      onClick={() => handleRequestSort("issue_date")}
                    >
                     Issue Date
                      {orderBy === "issue_date" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center"  className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "attribute_value"}
                      direction={orderBy === "attribute_value" ? order : "desc"}
                      onClick={() => handleRequestSort("attribute_value")}
                    >
                     Attribute
                      {orderBy === "attribute_value" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center"  className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "attribute_name"}
                      direction={orderBy === "attribute_name" ? order : "desc"}
                      onClick={() => handleRequestSort("attribute_name")}
                    >
                     Attribute Value
                      {orderBy === "attribute_name" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center" className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "price"}
                      direction={orderBy === "price" ? order : "desc"}
                      onClick={() => handleRequestSort("price")}
                    >
                Price
                      {orderBy === "price" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center" className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "quantity"}
                      direction={orderBy === "quantity" ? order : "desc"}
                      onClick={() => handleRequestSort("quantity")}
                    >
                Quantity
                      {orderBy === "price" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center" className="table-cell">
              <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "total_price"}
                      direction={orderBy === "total_price" ? order : "desc"}
                      onClick={() => handleRequestSort("total_price")}
                    >
                Total Price
                      {orderBy === "total_price" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel></StyledTableCell>
              <StyledTableCell align="center"></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
                  ? sortedRows.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : sortedRows
                ).map((row, i) => (
              <StyledTableRow key={row.sales_details_id }
         >
              <StyledTableCell align='center' component="th" scope="row" className='table-cell-border'>{row.sales_details_id}{markedForDelete.some((deletedRow) => deletedRow.salesDetailsId === row.sales_details_id)  && (
            <div className='centered-red-line' />)}</StyledTableCell>
                <StyledTableCell align="center"className='table-cell-border'>{row.product_name} {markedForDelete.some((deletedRow) => deletedRow.salesDetailsId === row.sales_details_id) && (
            <div className='centered-red-line' /> )}</StyledTableCell>
                <StyledTableCell align="center"className='table-cell-border'>{row.issue_date} {markedForDelete.some((deletedRow) => deletedRow.salesDetailsId === row.sales_details_id)  && (
            <div  className='centered-red-line' />  )}</StyledTableCell>
                <StyledTableCell align="center"className='table-cell-border'>{row.attribute_value} {markedForDelete.some((deletedRow) => deletedRow.salesDetailsId === row.sales_details_id)  && (
            <div  className='centered-red-line' /> )}</StyledTableCell>
                <StyledTableCell align="center"className='table-cell-border'>{row.attribute_name}{markedForDelete.some((deletedRow) => deletedRow.salesDetailsId === row.sales_details_id)  && (
            <div  className='centered-red-line'/> )}</StyledTableCell>
                <StyledTableCell align="center"className='table-cell-border'>{row.price} {markedForDelete.some((deletedRow) => deletedRow.salesDetailsId === row.sales_details_id)  && (
            <div  className='centered-red-line'/>)}</StyledTableCell>
                <StyledTableCell align="center" className="table-cell-border">
                {markedForDelete.some((deletedRow) => deletedRow.salesDetailsId === row.sales_details_id) && (
            <div className="centered-red-line" />
                   )}

  {row.quantity > 1 ? (
    <div>
      <input
       disabled={disabledRows.includes(row.sales_details_id)} // Disable if in disabledRows
        type="number"
        value={
          selectedQuantity[row.sales_details_id] !== undefined
            ? selectedQuantity[row.sales_details_id]
            : row.quantity
        }
        onChange={(e) => {
          const inputValue = e.target.value;

          // Allow backspace and validate input
          handleQuantityChange(row.sales_details_id, inputValue, row.quantity);
        }}
        style={{ width: "40px" }}
      />
      {validationErrors[row.sales_details_id] && (
        <div style={{ color: "red" }}>{validationErrors[row.sales_details_id]}</div>
      )}
    </div>
  ) : (
    <span>{row.quantity}</span> // Static display for quantity <= 1
  )}
</StyledTableCell>

<StyledTableCell align="center" className="table-cell-border">
  {/* Display total amount directly */}
  {row.price * (selectedQuantity[row.sales_details_id] || row.quantity)}
  
  {markedForDelete.some((deletedRow) => deletedRow.salesDetailsId === row.sales_details_id) && (
    <div className="centered-red-line" />
  )}
</StyledTableCell>

                  <StyledTableCell align="center"style={{ lineHeight: "10px", padding: "5px" }}>
                    <IconButton
                      color="black"  onClick={() => handleToggleDelete(row.sales_details_id, row.price,row.product_id,row.quantity,studentId,row.sales_id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </StyledTableCell>
              </StyledTableRow>

            ))}
              <TableRow>
        <TableCell colSpan={8} align="right" sx={{ fontWeight: 'bold', fontSize: '0.9rem', color:'#695a5a',padding:'13px',paddingRight:'70px' }}>
          Total Amount Refundable : {totalRefundable}
        </TableCell>
      </TableRow>
          </TableBody>
         
          <TableFooter>
                <TableRow>
                  <TablePagination
                    sx={{
                      backgroundColor: "#0A64A2",
                      color: "white",
                      width: "100%",
                    }}
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={9}
                    count={sortedRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
       
        </Table>
      </TableContainer>
      <div style={{display:'flex', justifyContent:'center', alignItems:'center',marginTop:'10px', gap:'10px'
      }}> <Button  className="save_update_btn"  variant="contained"  onClick={() => handleRefund()}>Refund</Button>
    </div>
  
      {/* Snackbar for Notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
          {/* Confirmation Modal */}
          <Modal open={isConfirmationOpen} onClose={cancelDelete}>
        <Box sx={ModalStyle} >
          <Typography sx={{fontSize:'1.1em', color:'#0A64A2'}} >
            {deleteMsg}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
  {markedForDelete.length > 0 && (
    <>
      <Button variant="contained" onClick={proceedToRefund} disabled={isLoading} className="no-btn">
        {isLoading ? "Saving..." :"Yes"}
      </Button>
      <Button variant="contained" onClick={cancelDelete} className="no-btn">
        No
      </Button>
    </>
  )}
   {!markedForDelete.length&& (
  <Button variant="contained" onClick={cancelDelete} className="no-btn">
    Ok
  </Button>
   )}
</Box>

        </Box>
      </Modal>

    </div>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#0A64A2',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },

}));